module.exports = __webpack_public_path__ + "img/tanker_orange.d3454627.svg";